export default "__VITE_ASSET__DJFeFaRl__"